import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"rgb(0,153,203)"} aria-hidden="true" aria-label="Answer logo" />;
};
